export default "__VITE_ASSET__6teVukiO__"